import React from 'react';
import { Table } from '../../components/Table';
import { useTheme } from '../../contexts/ThemeContext';

export const StockBalancePage: React.FC = () => {
  const { theme } = useTheme();

  return (
    <div className={`content-section ${theme.isDark ? 'dark' : 'light'}`}>
      <h2>Остатки товаров</h2>
      <Table
        title="Остатки на складах"
        columns={[
          { key: 'warehouse', title: 'Склад', width: '25%' },
          { key: 'product_name', title: 'Товар', width: '35%' },
          { key: 'quantity', title: 'Остаток', width: '15%' },
          { key: 'unit', title: 'Ед. изм.', width: '10%' },
          { key: 'status', title: 'Статус', width: '15%' }
        ]}
        data={[
          { id: '1', warehouse: 'Основной склад', product_name: 'Молоко 1л', quantity: '156', unit: 'шт', status: 'Норма', is_deleted: false },
          { id: '2', warehouse: 'Основной склад', product_name: 'Хлеб белый', quantity: '23', unit: 'шт', status: 'Мало', is_deleted: false },
          { id: '3', warehouse: 'Холодный склад', product_name: 'Мясо говядина', quantity: '89', unit: 'кг', status: 'Норма', is_deleted: false },
          { id: '4', warehouse: 'Основной склад', product_name: 'Рис 1кг', quantity: '0', unit: 'шт', status: 'Нет остатка', is_deleted: false }
        ]}
        theme={theme}
        readOnly={true}
      />
    </div>
  );
};
